import React from "react"
import PropTypes from "prop-types"

// components
import * as S from "app/static/frontend/search-new/components/FilterableListView/SearchActionButtons/style"

// hooks
import { useRefOverflow } from "app/static/frontend/imports/hooks"

export const SearchActionButtons = (props) => {
    const {
        overflow: leftOverflow,
        reference: leftActionButtons,
    } = useRefOverflow()
    const {
        overflow: rightOverflow,
        reference: rightActionButtons,
    } = useRefOverflow()

    return (
        <S.SearchActionButtons
            data-cy={props.dataCy}
            isProfile={props.isProfile}
        >
            <S.SearchActionButtonsLeftChildren
                data-cy="SearchActionButtonsLeftChildren"
                isProfile={props.isProfile}
                // TODO: change to ref after styled-components 4+ upgrade
                // https://styled-components.com/docs/advanced#refs
                ref={leftActionButtons}
            >
                {
                    (leftOverflow && props.leftChildrenGrouped)
                        ? props.leftChildrenGrouped
                        : props.leftChildren
                }
            </S.SearchActionButtonsLeftChildren>
            {
                props.middleChildren &&
                    <S.SearchActionButtonsMiddleChildren
                        data-cy="SearchActionButtonsMiddleChildren"
                    >
                        { props.middleChildren }
                    </S.SearchActionButtonsMiddleChildren>
            }
            <S.SearchActionButtonsRightChildren
                data-cy="SearchActionButtonsRightChildren"
                isProfile={props.isProfile}
                // TODO: change to ref after styled-components 4+ upgrade
                // https://styled-components.com/docs/advanced#refs
                ref={rightActionButtons}
            >
                {
                    (rightOverflow && props.rightChildrenGrouped)
                        ? props.rightChildrenGrouped
                        : props.rightChildren
                }
            </S.SearchActionButtonsRightChildren>
        </S.SearchActionButtons>
    )
}

SearchActionButtons.propTypes = {
    dataCy: PropTypes.string,
    isProfile: PropTypes.bool,
    leftChildren: PropTypes.arrayOf(PropTypes.element),
    leftChildrenGrouped: PropTypes.arrayOf(PropTypes.element),
    middleChildren: PropTypes.arrayOf(PropTypes.element),
    rightChildren: PropTypes.arrayOf(PropTypes.element),
    rightChildrenGrouped: PropTypes.arrayOf(PropTypes.element),
}

export default SearchActionButtons
